import React from 'react';
import { MicroCTA } from './shared/MicroCTA';
export function Chapter4() {
  return <section className="py-8 border-t border-gray-200" id="discovery" data-id="element-84">
      <h2 className="text-2xl font-bold mb-6" data-id="element-85">
        Upptäckten som förändrade min riktning
      </h2>
      <p className="mb-4 text-lg" data-id="element-86">
        Min research ledde mig genom en labyrint av information. Jag läste om
        Bacopa Monnieri, en ört som använts i tusentals år i traditionell
        medicin och som i moderna studier visat lovande resultat för minne och
        kognition. Jag läste om B-vitaminernas roll i hjärnans energiproduktion,
        om C-vitaminens skyddande egenskaper, om zinkens betydelse för
        nervsystemet.
      </p>
      <p className="mb-4 text-lg" data-id="element-87">
        Jag hittade en meta-analys – en studie som sammanfattar resultat från
        många andra studier – som visade att dessa näringsämnen tillsammans
        kunde ha en starkare effekt än var för sig. Det var som att lägga ihop
        pusselbitar från forskarnas whiteboard.
      </p>
      <p className="mb-4 text-lg" data-id="element-88">
        En kväll, efter timmar framför datorn, snubblade jag över Brainy – ett
        kosttillskott vars formulering matchade exakt det jag läst om. Ingen
        överdrivet sensationell marknadsföring. Inga löften om att bli ett geni
        över natten. Bara en tydlig förklaring av ingredienserna och deras
        potentiella fördelar, backat av forskning.
      </p>
      <div className="bg-white p-6 rounded-lg shadow-sm my-6" id="ingredients" data-id="element-89">
        <h3 className="text-xl font-bold mb-3 text-[#2e7d32]" data-id="element-90">Vad är Brainy</h3>
        <ul className="list-disc pl-5 space-y-2" data-id="element-91">
          <li data-id="element-92">
            <strong data-id="element-93">Bacopa Monnieri</strong>
          </li>
          <li data-id="element-94">
            <strong data-id="element-95">B-vitaminer</strong> (B1, B2, B3/niacin, B5, B6, B7/biotin,
            B12)
          </li>
          <li data-id="element-96">
            <strong data-id="element-97">C-vitamin, zink, folsyra</strong>
          </li>
          <li data-id="element-98">
            <strong data-id="element-99">Stimulantia-fritt</strong> (inget koffein)
          </li>
          <li data-id="element-100">
            <strong data-id="element-101">Dosering:</strong> 2 kapslar/dag
          </li>
          <li data-id="element-102">
            <strong data-id="element-103">180 dagars pengarna-tillbaka-garanti</strong> •{' '}
            <strong data-id="element-104">Gratis leverans</strong>
          </li>
        </ul>
      </div>
      <p className="mb-4 text-lg" data-id="element-105">
        Jag tvekade. Är detta bara ett till försök som kommer att leda till
        besvikelse? Men så tänkte jag på vad Dr. Lindholm hade sagt om att
        stödja kroppens egna processer. Jag tänkte på Karins ord om att det inte
        är svaghet att söka stöd.
      </p>
      <p className="mb-4 text-lg" data-id="element-106">
        Jag bestämde mig för att ge det två månader. Inte för en revolution –
        för en rutin. Jag ville se om detta, tillsammans med de andra
        förändringarna jag redan gjort – bättre sömn, mer rörelse, hälsosammare
        kost – kunde göra skillnad.
      </p>
      <p className="mb-4 text-lg" data-id="element-107">
        Jag började föra dagbok. Tre rader varje kväll: Vad gick bra? Vad var
        svårt? Hur kände jag mig? Jag tog två kapslar med frukosten. Jag gick en
        kort promenad efter middagen. Jag la mobilen i hallen klockan 21.
      </p>
      <div className="mt-6" data-id="element-108">
        <MicroCTA text="Min åtta veckors resa" href="#protocol" className="text-right" data-id="element-109" />
      </div>
    </section>;
}